import script from "./BookingInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingInfo.vue?vue&type=script&setup=true&lang=js"

import "./BookingInfo.vue?vue&type=style&index=0&id=5bd60ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd60ef4"]])

export default __exports__